module.exports = __webpack_public_path__ + "img/campus-3.e14e1030.png";